import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuthClient } from '@/lib/authClient';
import { useDeviceConnection } from '@/hooks/use-device-connection';

export function RequireSessionOnly() {
  const location = useLocation();
  const { session } = useAuthClient();
  const { isPending, error, data } = session;

  // Check whether a mobile device is already connected after login
  const { isChecking, isConnected } = useDeviceConnection();

  if (isPending) return null;
  if (error) return <Navigate to="/signin" replace />;
  if (!data)
    return <Navigate to="/signin" replace state={{ from: location }} />;
  if (isChecking) return null;

  // Case: mobile connected, redirect to base page
  if (isConnected) return <Navigate to="/" replace />;

  // Case: mobile not connected, continue to route
  return <Outlet />;
}
